module.exports = __webpack_public_path__ + "static/img/3.2.f7e7ceb.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/2/zh/3.2.png
// module id = F/Ju
// module chunks = 0